import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Invitations = () => {

  const  servicesFaqData = [
    { 
        question: "What are invitation cards, and where are they used?  ", 
        answer: "Invitation cards are printed materials designed to invite guests to events such as weddings, parties, corporate functions, and formal gatherings. These cards serve as the first impression of your event, reflecting its tone, style, and theme. Invitations are commonly used to convey essential details like the date, time, venue, and RSVP information. Customised invitation cards add a personal touch, making them suitable for both professional and personal events. They help set the stage for the event, creating excitement and anticipation among recipients."
    },
    { 
        question: "What are the benefits of custom invitation card printing?   ", 
        answer: "Custom invitation card printing allows you to design invitations that align with your event's theme, style, or branding. Personalisation options such as unique layouts, colours, fonts, and embellishments ensure that your invitations stand out. High-quality printing adds a professional and elegant touch, leaving a lasting impression on recipients. Customised invitations also allow you to incorporate logos, personal messages, or special design elements. This level of detail ensures that your cards are memorable and perfectly suited to the occasion."
    },
    { 
        question: "Can Printingy handle bulk orders for invitations cards printing?  ", 
        answer: "Yes, Printingy specialises in bulk printing of invitation cards, offering cost-effective solutions for large-scale events. Bulk printing reduces per-unit costs, making it an economical option for weddings, corporate events, and large gatherings. Our advanced printing technology ensures consistent quality across all cards, regardless of the order size. With quick turnaround times, we guarantee timely delivery even for urgent or large orders. Whether for a grand celebration or a professional event, Printingy provides reliable and efficient bulk printing services."
    },
    { 
        question: "What materials are used for wedding & party invitation cards printing?  ", 
        answer: "Our wedding & party invitation cards printing services use premium materials such as textured cardstock, metallic paper, and glossy finishes. Textured cardstock adds elegance and sophistication, perfect for formal weddings and upscale parties. Metallic paper offers a luxurious shimmer, ideal for creating eye-catching designs. Glossy finishes enhance the vibrancy of colours and details, making the invitations stand out. Each material is carefully chosen to match the style and tone of your event, ensuring a high-quality and durable final product."
    },
    { 
        question: "What industries and individuals benefit from custom invitation card printing services? ", 
        answer: "Event planners, corporate organisers, and individuals benefit greatly from custom invitation card printing services. Event planners rely on these services to create elegant and unique invitations for weddings, galas, and themed parties. Corporate organisers use printed invitations for company events, product launches, and formal gatherings. Individuals use personalised invitation cards for birthdays, anniversaries, and private celebrations. Custom invitation cards add a professional and personal touch, making them an essential tool for effective communication and event planning."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing of Invitations');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title=" Custom Invitation Card Printing Services"
  description="High-quality printing of invitations and invitation cards for events and weddings. Bulk custom invitation card printing and wedding & party invitation cards solutions."
  keywords="Printing of Invitations,
Printing of Invitation Cards,
Invitations Cards Printing,
Wedding & Party Invitation Cards Printing,
Custom Invitation Card Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Invitations </h1>
              <h2 className="text-muted">Customised invitation cards for weddings, parties, and corporate events   </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Invitations set the tone for your event, creating excitement and anticipation among recipients. Printingy specialises in Printing of Invitations, offering high-quality printing of invitation cards for weddings, corporate events, parties, and more.</p>
          <p>Our services include custom invitation card printing, tailored to your unique requirements, ensuring your invitations stand out with elegance and creativity. We also provide specialised wedding & party invitation cards printing, delivering luxurious and vibrant designs for memorable occasions. Whether for personal celebrations or professional events, Printingy ensures premium materials and high-resolution prints to leave a lasting impression.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Invitation Card Printing Solutions </h2>
                <h3 className="large-hed">Elegant, high-quality invitations for every occasion  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Invitations for all types of events.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing of invitation cards with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised invitations cards printing tailored to your theme.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional wedding & party invitation cards printing with luxurious finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution visuals and premium materials for a sophisticated appearance.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology ensuring vibrant and fade-resistant colours.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for individuals, event planners, and corporate organisers.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/invitations.jpg" // Path relative to the public folder
                  alt="Professional printing of invitations services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Invitations Delivered On Time  </h2>
            <h3 className="small-hed">Focus on your event while we handle your invitation printing needs   </h3>
            <p>At Printingy, we use state-of-the-art printing techniques and premium materials to deliver exceptional custom invitation card printing. Whether for a wedding, party, or corporate event, our services ensure your invitations are visually stunning and memorable.
            </p>
            <p>We prioritise efficiency and quality, guaranteeing that your invitations are delivered on schedule, whether for small or bulk orders. Partner with Printingy for elegant and reliable invitation printing solutions.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Invitations;
